import React, { useState, useEffect } from 'react';
import { Form, Button, Spinner, Row, Col } from 'react-bootstrap';
import { useQuery, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { Get, Post, Put } from '../../../../../utils/httpProvider';
import { DECUONGNGHIENCUU_API, DANHGIA_THISINH_API, BaseGatewayImage } from '../../../../../utils/apiUrl';
import DocumentInput from '../../../../../components/document-input/DocumentInput';

const DanhGiaThiSinhForm = ({ hoSoId, dataDeCuong, readOnly = false, refetchHoSo = () => {}, handleClose = () => {} }) => {
    const queryClient = useQueryClient();
    const [saving, setSaving] = useState(false);
    
    const [diemHoSo, setDiemHoSo] = useState('');
    const [diemDeCuong, setDiemDeCuong] = useState('');
    const [fileBienBanHoSo, setFileBienBanHoSo] = useState('');
    const [fileBienBanDeCuong, setFileBienBanDeCuong] = useState('');
    const [chamHoSoNgay, setChamHoSoNgay] = useState('');
    const [soQuyetDinhDeCuong, setSoQuyetDinhDeCuong] = useState('');
    const [ngayQuyetDinhDeCuong, setNgayQuyetDinhDeCuong] = useState('');
    const [fileQuyetDinh, setFileQuyetDinh] = useState('');
    const [chamDeCuongNgay, setChamDeCuongNgay] = useState('');
    const [nhanXet, setNhanXet] = useState(dataDeCuong?.nhanXet || '');

    useEffect(() => {
        if (dataDeCuong !== undefined) {
            setNhanXet(dataDeCuong?.nhanXet || '');
        }
    }, [dataDeCuong]);

    // Get current score data
    const { data: danhGiaRes, refetch: refetchDanhGia } = useQuery(
        ['danhGiaThiSinh', hoSoId], 
        () => Get(`${DANHGIA_THISINH_API.GET_BY_HOSO_ID}/${hoSoId}`),
        { 
            enabled: !!hoSoId,
            refetchOnWindowFocus: false 
        }
    );

    const danhGiaThiSinh = danhGiaRes?.data || danhGiaRes || null;

    useEffect(() => {
        if (danhGiaThiSinh && danhGiaThiSinh.id) {
            setDiemHoSo(danhGiaThiSinh.diemHoSo !== null ? danhGiaThiSinh.diemHoSo : '');
            setDiemDeCuong(danhGiaThiSinh.diemDeCuong !== null ? danhGiaThiSinh.diemDeCuong : '');
            setFileBienBanHoSo(danhGiaThiSinh.fileBienBanHoSo || '');
            setFileBienBanDeCuong(danhGiaThiSinh.fileBienBanDeCuong || '');
            setChamHoSoNgay(danhGiaThiSinh.chamHoSoNgay ? danhGiaThiSinh.chamHoSoNgay.split('T')[0] : '');
            setSoQuyetDinhDeCuong(danhGiaThiSinh.soQuyetDinhDeCuong || '');
            setNgayQuyetDinhDeCuong(danhGiaThiSinh.ngayQuyetDinhDeCuong ? danhGiaThiSinh.ngayQuyetDinhDeCuong.split('T')[0] : '');
            setFileQuyetDinh(danhGiaThiSinh.fileQuyetDinh || '');
            setChamDeCuongNgay(danhGiaThiSinh.chamDeCuongNgay ? danhGiaThiSinh.chamDeCuongNgay.split('T')[0] : '');
        }
    }, [danhGiaThiSinh]);

    const parseScore = (val) => {
        if (val === null || val === undefined || val === '') return NaN;
        if (typeof val === 'string') return parseFloat(val.replace(',', '.'));
        return parseFloat(val);
    };

    const parsedHoSo = parseScore(diemHoSo);
    const parsedDeCuong = parseScore(diemDeCuong);

    const diemTong = (!isNaN(parsedHoSo) && !isNaN(parsedDeCuong)) 
        ? (parsedHoSo + parsedDeCuong).toFixed(2) 
        : '';

    const handleSave = async () => {
        if (isNaN(parsedHoSo) || isNaN(parsedDeCuong)) {
            toast.warning('Vui lòng nhập đầy đủ Điểm hồ sơ và Điểm đề cương.');
            return;
        }

        setSaving(true);
        try {
            const dataToSave = {
                hoSoTuyenSinhId: hoSoId,
                diemHoSo: parsedHoSo,
                diemDeCuong: parsedDeCuong,
                diemTong: parseFloat(diemTong),
                fileBienBanHoSo,
                fileBienBanDeCuong,
                chamHoSoNgay: chamHoSoNgay || null,
                soQuyetDinhDeCuong,
                ngayQuyetDinhDeCuong: ngayQuyetDinhDeCuong || null,
                fileQuyetDinh,
                chamDeCuongNgay: chamDeCuongNgay || null
            };

            // Save DanhGiaThiSinh
            if (danhGiaThiSinh && danhGiaThiSinh.id) {
                await Put(DANHGIA_THISINH_API.UPDATE_ITEM, danhGiaThiSinh.id, dataToSave);
            } else {
                await Post(DANHGIA_THISINH_API.CREATE_ITEM, null, dataToSave);
            }

            // Save NhanXet
            if (dataDeCuong && (dataDeCuong.id || dataDeCuong.Id)) {
                const deCuongId = dataDeCuong.id || dataDeCuong.Id;
                const dataDeCuongUpdate = {
                    ...dataDeCuong,
                    nhanXet: nhanXet
                };
                await Put(DECUONGNGHIENCUU_API.UPDATE_ITEM, deCuongId, dataDeCuongUpdate);
            }

            toast.success('Lưu kết quả đánh giá thành công!');
            await refetchDanhGia();
            await queryClient.invalidateQueries(['deCuong', hoSoId]);
            refetchHoSo();
            handleClose();
        } catch (error) {
            console.error(error);
            toast.error('Có lỗi xảy ra khi lưu kết quả.');
        } finally {
            setSaving(false);
        }
    };

    const getSafeUrl = (path) => {
        if (!path) return null;
        if (path.startsWith('http')) return path;
        const baseUrl = BaseGatewayImage.endsWith('/') ? BaseGatewayImage.slice(0, -1) : BaseGatewayImage;
        const safePath = path.startsWith('/') ? path : `/${path}`;
        return `${baseUrl}${safePath}`;
    };

    return (
        <div className="bg-light p-3 rounded border">
            {dataDeCuong && (dataDeCuong.id || dataDeCuong.Id) && (
                <div 
                    className="mb-4 p-3 rounded shadow-sm" 
                    style={{ backgroundColor: '#f4f7fb', border: '1px solid #e1e8f0', borderLeft: '4px solid #4a90e2' }}
                >
                    <h6 className="font-weight-bold mb-3" style={{ color: '#2c3e50' }}>
                        <i className="fas fa-info-circle mr-2" style={{ color: '#4a90e2' }}></i>
                        Thông tin đề cương nghiên cứu
                    </h6>
                    <div className="row" style={{ color: '#495057' }}>
                        <div className="col-md-12 mb-2">
                            <strong style={{ color: '#34495e' }}>Tên đề cương: </strong> {dataDeCuong?.tenDeCuong || <span className="text-muted font-italic">Chưa cập nhật</span>}
                        </div>
                        <div className="col-md-12 mb-2">
                            <strong style={{ color: '#34495e' }}>File minh chứng: </strong> 
                            {dataDeCuong?.fileMinhChung ? (
                                <div className="mt-1">
                                    <a href={getSafeUrl(dataDeCuong.fileMinhChung)} target="_blank" rel="noreferrer" className="btn btn-outline-primary btn-sm text-left" style={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'inline-block' }} title={dataDeCuong.fileMinhChung.split('/').pop().replace(/_\d{14}(?=\.\w+$|$)/, '')}>
                                        <i className="fas fa-paperclip mr-1"></i> {dataDeCuong.fileMinhChung.split('/').pop().replace(/_\d{14}(?=\.\w+$|$)/, '')}
                                    </a>
                                </div>
                            ) : <span className="text-muted font-italic">Không có</span>}
                        </div>
                        {dataDeCuong?.canBoHuongDans && dataDeCuong.canBoHuongDans.length > 0 && (
                            <div className="col-md-12">
                                <strong style={{ color: '#34495e' }}>Cán bộ hướng dẫn: </strong>
                                <ul className="mb-0 mt-1 pl-4">
                                    {dataDeCuong.canBoHuongDans.map((cb, idx) => (
                                        <li key={idx}>
                                            {cb.hoTen} {cb.donViCongTac ? `- ${cb.donViCongTac}` : ''}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </div>
                </div>
            )}

            <h5 className="font-weight-bold text-primary mb-3">Đánh giá điểm số</h5>
            
            <div className="border rounded mb-4 shadow-sm" style={{ backgroundColor: '#f8f9fa' }}>
                <div className="p-3 border-bottom bg-white rounded-top">
                    <h6 className="font-weight-bold text-info mb-0 text-uppercase"><i className="fas fa-file-alt mr-2"></i> 1. Đánh giá hồ sơ</h6>
                </div>
                <div className="p-3">
                    <Row>
                    <Col md={6}>
                        <Form.Group>
                            <Form.Label style={{ fontWeight: 500 }}>Phiếu chấm điểm hồ sơ ngày</Form.Label>
                            <Form.Control type="date" value={chamHoSoNgay} onChange={(e) => setChamHoSoNgay(e.target.value)} disabled={readOnly} />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group>
                            <Form.Label className="text-danger" style={{ fontWeight: 500 }}>Điểm hồ sơ <span className="text-danger">*</span></Form.Label>
                            <Form.Control 
                                type="text" 
                                value={diemHoSo} 
                                onChange={(e) => setDiemHoSo(e.target.value)}
                                disabled={readOnly}
                                placeholder="Nhập điểm hồ sơ"
                                className="font-weight-bold text-danger custom-placeholder"
                            />
                        </Form.Group>
                    </Col>
                    <Col md={12}>
                        <Form.Group className="mb-3">
                            <DocumentInput
                                labelTitle={<span className="font-weight-bold">File phiếu chấm điểm hồ sơ</span>}
                                value={fileBienBanHoSo}
                                onChangeProp={(path) => setFileBienBanHoSo(path)}
                                disabled={readOnly}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                </div>
            </div>

            <div className="border rounded mb-4 shadow-sm" style={{ backgroundColor: '#f8f9fa' }}>
                <div className="p-3 border-bottom bg-white rounded-top">
                    <h6 className="font-weight-bold text-info mb-0 text-uppercase"><i className="fas fa-book-open mr-2"></i> 2. Đánh giá đề cương nghiên cứu</h6>
                </div>
                <div className="p-3">
                    <Row>
                    <Col md={6}>
                        <Form.Group>
                            <Form.Label style={{ fontWeight: 500 }}>Số quyết định thành lập ban đánh giá đề cương</Form.Label>
                            <Form.Control type="text" value={soQuyetDinhDeCuong} onChange={(e) => setSoQuyetDinhDeCuong(e.target.value)} disabled={readOnly} placeholder="Nhập số quyết định đề cương" />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group>
                            <Form.Label style={{ fontWeight: 500 }}>Ngày quyết định thành lập ban đánh giá đề cương</Form.Label>
                            <Form.Control type="date" value={ngayQuyetDinhDeCuong} onChange={(e) => setNgayQuyetDinhDeCuong(e.target.value)} disabled={readOnly} />
                        </Form.Group>
                    </Col>
                    <Col md={12}>
                        <Form.Group className="mb-3">
                            <DocumentInput
                                labelTitle={<span className="font-weight-bold">File quyết định</span>}
                                value={fileQuyetDinh}
                                onChangeProp={(path) => setFileQuyetDinh(path)}
                                disabled={readOnly}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group>
                            <Form.Label style={{ fontWeight: 500 }}>Biên bản chấm đề cương ngày</Form.Label>
                            <Form.Control type="date" value={chamDeCuongNgay} onChange={(e) => setChamDeCuongNgay(e.target.value)} disabled={readOnly} />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group>
                            <Form.Label className="text-danger" style={{ fontWeight: 500 }}>Điểm đề cương nghiên cứu <span className="text-danger">*</span></Form.Label>
                            <Form.Control 
                                type="text" 
                                value={diemDeCuong} 
                                onChange={(e) => setDiemDeCuong(e.target.value)}
                                disabled={readOnly}
                                placeholder="Nhập điểm đề cương nghiên cứu"
                                className="font-weight-bold text-danger custom-placeholder"
                            />
                        </Form.Group>
                    </Col>
                    <Col md={12}>
                        <Form.Group className="mb-3">
                            <DocumentInput
                                labelTitle={<span className="font-weight-bold">File biên bản chấm điểm đề cương</span>}
                                value={fileBienBanDeCuong}
                                onChangeProp={(path) => setFileBienBanDeCuong(path)}
                                disabled={readOnly}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                </div>
            </div>
            
            <div className="border rounded border-success mb-4 shadow-sm">
                <div className="p-3 bg-light text-center rounded">
                    <Row>
                        <Col md={12}>
                            <Form.Group className="mb-0">
                                <Form.Label className="font-weight-bold text-success text-center w-100" style={{ fontSize: '1.1rem', textTransform: 'uppercase' }}>Điểm Tổng</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    value={diemTong} 
                                    disabled
                                    className="shadow-none font-weight-bold text-danger text-center mx-auto"
                                    style={{ fontSize: '1.5rem', height: 'auto', padding: '10px', backgroundColor: '#fff', border: '1px solid #28a745', maxWidth: '200px' }}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </div>
            </div>
            
            <div className="mt-4">
                <Form.Group>
                    <Form.Label className="font-weight-bold">Nhận xét của Hội đồng</Form.Label>
                    <Form.Control 
                        as="textarea" 
                        rows={3} 
                        value={nhanXet} 
                        onChange={(e) => setNhanXet(e.target.value)} 
                        disabled={readOnly}
                        placeholder="Nhập nhận xét đánh giá..."
                    />
                </Form.Group>
            </div>
            
            {!readOnly && (
                <div className="text-right mt-3">
                    <Button variant="primary" onClick={handleSave} disabled={saving}>
                        {saving ? <><Spinner size="sm" animation="border" className="mr-2" /> Đang lưu...</> : <><i className="fas fa-save mr-2"></i> Lưu đánh giá</>}
                    </Button>
                </div>
            )}
        </div>
    );
};

export default DanhGiaThiSinhForm;
